package com.dignicate.web.data.content.static.shared

import com.dignicate.web.data.content.CompanyContentDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedTexts

class CompanyContentSource {
    fun company(): CompanyContentDto {
        val companyName = LocalizedTexts.Companion.of(
            Language.Ja to "ディグニケート合同会社（Dignicate, LLC）",
            Language.En to "Dignicate, LLC"
        )

        val addressValue = LocalizedTexts.Companion.of(
            Language.Ja to "〒160-0023 東京都新宿区西新宿3-1-5 新宿嘉泉ビル8階",
            Language.En to "Shinjuku-Kasen BLDG 8F, 3-1-5, Nishi-Shinjuku, Shinjuku, Tokyo, Japan"
        )

        val representativeValue = LocalizedTexts.Companion.of(
            Language.Ja to "渡部 伸一（Shinichi Watanabe）",
            Language.En to "Shinichi Watanabe"
        )

        val foundedValue = LocalizedTexts.Companion.of(
            Language.Ja to "2019年（令和元年）5月20日",
            Language.En to "20 May 2019"
        )

        val capitalValue = LocalizedTexts.Companion.of(
            Language.Ja to "1,000,000円",
            Language.En to "JPY 1,000,000"
        )

        // Localized labels for each item
        val labelAddress = LocalizedTexts.Companion.of(
            Language.Ja to "住所",
            Language.En to "Address"
        )

        val labelRepresentative = LocalizedTexts.Companion.of(
            Language.Ja to "代表者",
            Language.En to "Representative"
        )

        val sublabelRepresentative = LocalizedTexts.Companion.of(
            Language.Ja to "上級執行役員兼経営担当者",
            Language.En to "Executive Programmer and Operator in Chief"
        )

        val labelFounded = LocalizedTexts.Companion.of(
            Language.Ja to "設立",
            Language.En to "Founded"
        )

        val labelCapital = LocalizedTexts.Companion.of(
            Language.Ja to "資本金",
            Language.En to "Capital"
        )

        val items = listOf(
            CompanyContentDto.Item(label = labelAddress, value = addressValue),
            CompanyContentDto.Item(
                label = labelRepresentative,
                sublabel = sublabelRepresentative,
                value = representativeValue,
            ),
            CompanyContentDto.Item(label = labelFounded, value = foundedValue),
            CompanyContentDto.Item(label = labelCapital, value = capitalValue)
        )

        return CompanyContentDto(
            companyName = companyName,
            items = items
        )
    }
}
